import { Option } from '~/components/Select';

const consumer: Option = {
  value: 'CONSUMER',
  label: 'Consumer',
};

const licensee: Option = {
  value: 'LICENSEE',
  label: 'Licensee',
};

export const recipientTypeOptions = [consumer, licensee];
